// TODO change to NodeType with name and rule
// TODO add getNodeTypes in each rule
const NodeName = Object.freeze({
    ROOT: 'ROOT',
    WRITING_PRACTICE: 'WRITING_PRACTICE',
    TEXT: 'TEXT',
    LINE_FEED: 'LINE_FEED',
    PIPE: 'PIPE',
    TITLE_1: 'TITLE_1',
    TITLE_2: 'TITLE_2',
    TITLE_3: 'TITLE_3',
    EMPHASIS_UNDEFINED: 'EMPHASIS_UNDEFINED',
    EMPHASIS_BOLD: 'EMPHASIS_BOLD',
    EMPHASIS_ITALIC: 'EMPHASIS_ITALIC',
    EMPHASIS_BOLD_ITALIC: 'EMPHASIS_BOLD_ITALIC',
    HIDDEN_INPUT: 'HIDDEN_INPUT',
    COLOR: 'COLOR',
    AUDIO: 'AUDIO',
    MEDIA_ID: 'MEDIA_ID',
    TABLE: 'TABLE',
    TABLE_HEADER: 'TABLE_HEADER',
    TABLE_ROW: 'TABLE_ROW',
    TABLE_COLUMN: 'TABLE_COLUMN',
});

export {NodeName}